<app-modal *ngIf="vo$ | async; let vo">
	<div
		modal-body
		class="app-subscription-confirmation-popup">

		<ng-container [ngSwitch]="vo.action">
			<ng-container *ngSwitchCase="SubscriptionAction.Delete">
				<!-- alert info -->
				<dc-alert
					*ngIf="!vo.isMultipleElement" type="error" message="info"
					i18n-message="@@subscription.action.confirmation.popup.delete.info"></dc-alert>
				<dc-alert
					*ngIf="vo.isMultipleElement" type="error" message="multiple-info"
					i18n-message="@@subscription.action.confirmation.popup.delete.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.delete.description">
					deletion-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.delete.multiple.description">
					deletion-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.Initialize">
				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.initialize.description">
					initialize-request</span>
				<span
					*ngIf="vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.initialize.multiple.description">
					initialize-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.UpdateData">
				<!-- alert info -->
				<dc-alert type="info" message="info"
									i18n-message="@@subscription.action.confirmation.popup.updateData.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.updateData.description">
					update-data-request</span>

				<span
					*ngIf="vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.updateData.multiple.description">
					update-data-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.ClearData">
				<!-- alert info -->
				<dc-alert *ngIf="!vo.isMultipleElement" type="error" variant="outline" message="info"
									i18n-message="@@subscription.action.confirmation.popup.clearData.info"></dc-alert>

				<dc-alert *ngIf="vo.isMultipleElement" type="error" variant="outline" message="info"
									i18n-message="@@subscription.action.confirmation.popup.clearData.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.clearData.description">
					clear-data-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.Deactivate">
				<!-- alert info -->
				<dc-alert *ngIf="!vo.isMultipleElement" type="warning" message="warn"
									i18n-message="@@subscription.action.confirmation.popup.deactivate.info"></dc-alert>

				<dc-alert *ngIf="vo.isMultipleElement" type="warning" message="warn"
									i18n-message="@@subscription.action.confirmation.popup.deactivate.multiple.info"></dc-alert>

				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.deactivate.description">
					deactivate-request</span>

				<span
					*ngIf="vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.deactivate.multiple.description">
					deactivate-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.Activate">
				<!-- description request -->
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.activate.description">
					activate-request</span>

				<span
					*ngIf="vo.isMultipleElement"
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.activate.multiple.description">
					activate-multiple-request</span>
			</ng-container>

			<ng-container *ngSwitchCase="SubscriptionAction.UpdateColumns">
				<!-- alert info -->
				<dc-alert type="warning" message="warn"
									i18n-message="@@subscription.action.confirmation.popup.updateColumns.info"></dc-alert>

				<!-- description request -->
				<span
					class="app-subscription-confirmation-popup__description"
					i18n="@@subscription.action.confirmation.popup.updateColumns.description">
					update-columns-request</span>
			</ng-container>
		</ng-container>

		<div class="app-subscription-confirmation-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElement">
					concerned-element</span>

				<span class="app-subscription-confirmation-popup__element-label">
					{{ vo.element | truncate: 30: 1 : 'end' }}</span>
			</ng-container>

			<ng-container *ngIf="vo.isMultipleElement">
				<span
					i18n="@@subscription.action.confirmation.popup.concernedElements">
					concerned-elements</span>

				<div class="app-subscription-confirmation-popup__element-label">
					{{ vo.subscriptionId.length }}
					<span
						i18n="@@subscription.action.confirmation.popup.subscriptions">
						subscriptions</span>
				</div>
			</ng-container>
		</div>

		<mat-checkbox
			*ngIf="vo.action === SubscriptionAction.Delete"
			id="{{ cmpId }}-confirm-delete-checkbox"
			color="primary"
			[(ngModel)]="confirmDeletion">
				<span
					*ngIf="vo.action === SubscriptionAction.Delete"
					i18n="@@subscription.action.confirmation.popup.delete.confirm">
					confirm-delete</span>
		</mat-checkbox>
	</div>

	<div modal-footer  class="app-subscription-confirmation-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="SubscriptionAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.delete.btn">
					delete</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.Initialize"
				id="{{ cmpId }}-initialize-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Publish"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.initialize.btn">
					initialize</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.UpdateData"
				id="{{ cmpId }}-update-data-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Input"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.updateData.btn">
					update-data</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.ClearData"
				id="{{ cmpId }}-clear-data-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'warn'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Output"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.clearData.btn">
					clear-data</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.Deactivate"
				id="{{ cmpId }}-deactivate-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.ShareOff"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.deactivate.btn">
					deactivate</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.Activate"
				id="{{ cmpId }}-activate-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Share"></mat-icon>
				<span
					i18n="@@subscription.action.confirmation.popup.activate.btn">
					activate</span>
			</button>

			<button
				*ngSwitchCase="SubscriptionAction.UpdateColumns"
				id="{{ cmpId }}-activate-btn"
				class="app-subscription-confirmation-popup__footer__btn"
				[color]="'primary'"
				(click)="launchAction()"
				mat-raised-button>
				<span
					i18n="@@subscription.action.confirmation.popup.updateColumns.btn">
					update-columns</span>
			</button>
		</ng-container>
	</div>
</app-modal>
